"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../helpers");
var Wizard_1 = require("../Wizard");
var MIN_WIDTH_TAB_LIST_LAYOUT = '63px';
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    flex-shrink: 0;\n\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    margin: 0;\n    padding-left: 0;\n\n    width: ", ";\n    min-width: ", ";\n\n    ", "\n"], ["\n    box-sizing: border-box;\n    flex-shrink: 0;\n\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    margin: 0;\n    padding-left: 0;\n\n    width: ", ";\n    min-width: ", ";\n\n    ",
    "\n"])), function (_a) {
    var width = _a.width;
    return (width ? (typeof width === 'string' ? width : width + "px") : '195px');
}, MIN_WIDTH_TAB_LIST_LAYOUT, function (_a) {
    var theme = _a.theme, _b = _a.backgroundView, backgroundView = _b === void 0 ? Wizard_1.WIZARD_TABS_BACKGROUND_VIEW.transparent : _b;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background: ", ";\n\n        /* Spacer element for border right */\n        &:after {\n            content: '';\n            display: block;\n            flex: 1 1 0;\n            border-right: ", " solid ", ";\n        }\n    "], ["\n        background: ",
        ";\n\n        /* Spacer element for border right */\n        &:after {\n            content: '';\n            display: block;\n            flex: 1 1 0;\n            border-right: ", " solid ", ";\n        }\n    "])), backgroundView === Wizard_1.WIZARD_TABS_BACKGROUND_VIEW.transparent
        ? 'transparent'
        : theme.colorBackgroundNeutralLight, helpers_1.BASE_BORDER_WIDTH, theme.colorBorderMain);
});
exports.TabListLayout = helpers_1.createUIElement('TabListLayout', function (_a, ref) {
    var className = _a.className, children = _a.children, width = _a.width, backgroundView = _a.backgroundView, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "width", "backgroundView", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'tablistlayout', className: "vm-TabListLayout " + className, width: width, backgroundView: backgroundView, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=TabListLayout.js.map